import { render } from "./DataQuery.vue?vue&type=template&id=6d1c52c8&scoped=true"
import script from "./DataQuery.vue?vue&type=script&lang=js"
export * from "./DataQuery.vue?vue&type=script&lang=js"

import "./DataQuery.vue?vue&type=style&index=0&id=6d1c52c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1c52c8"]])

export default __exports__